import React from 'react';
import { useSelector } from 'react-redux';

import { Course } from 'redux/schemas/models/course';
import { gray7 } from 'styles/global_defaults/colors';
import { Enrollment } from 'redux/schemas/models/my-account';
import OfferingCard from 'offerings/components/offering-card';
import { getCurrentJourney } from 'redux/selectors/learning-journeys';
import NvSubmissionGallery from 'shared/components/nv-submission-gallery';
import { journeyCollectionContext } from 'learning_journeys/components/details';
import {
  largeSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import { CombinedCourse } from 'redux/schemas';

type Props = {
  courses: CombinedCourse[],
};

const CoursesCarousel = (props: Props) => {
  const {
    courses,
  } = props;

  const currentJourney = useSelector(getCurrentJourney);

  const {
    getIsCourseLocked,
  } = React.useContext(journeyCollectionContext);

  return (
    <NvSubmissionGallery
      spacing={largeSpacing}
      topPadding={standardSpacing}
      bottomPadding={standardSpacing}
      carouselModeBackgroundColor={gray7}
    >
      {courses.map((course, index) => (
        <OfferingCard
          offering={course}
          position={index + 1}
          key={course.catalogId}
          parent={currentJourney}
          locked={getIsCourseLocked(index)}
        />
      ))}
    </NvSubmissionGallery>
  );
};

export default CoursesCarousel;
